import { supabase } from '../supabaseClient';
import type { Bounds } from './consts';
import type { CreateAlertCriteria } from './alertCriteria';
export {
  alertCriteriaRows,
  buildAlertCriteria,
  describeAlertCriteria,
  isBroadAlert,
  type CreateAlertCriteria,
} from './alertCriteria';

export type ManagedAlert = {
  alert_id: string;
  email: string;
  alert_status: 'pending' | 'active' | 'paused' | 'unsubscribed';
  location_mode: 'named' | 'viewport' | 'all';
  location_name: string | null;
  bounds: Bounds | null;
  max_price_idr: number | null;
  min_bedrooms: number | null;
  keywords: string[];
  display_currency: string;
  created_at: string;
};

export async function createEmailAlert(criteria: CreateAlertCriteria) {
  const { data, error } = await supabase.rpc('create_email_alert', {
    p_email: criteria.email,
    p_location_mode: criteria.location_mode,
    p_location_name: criteria.location_name,
    p_bounds: criteria.bounds,
    p_max_price_idr: criteria.max_price_idr,
    p_min_bedrooms: criteria.min_bedrooms,
    p_keywords: criteria.keywords,
    p_display_currency: criteria.display_currency,
  });
  if (error) throw error;
  return data?.[0];
}

export async function confirmEmailAlert(token: string) {
  const { data, error } = await supabase.rpc('confirm_email_alert', { p_token: token });
  if (error) throw error;
  return data?.[0];
}

export async function getManagedAlert(token: string): Promise<ManagedAlert | null> {
  const { data, error } = await supabase.rpc('get_email_alert_for_management', { p_token: token });
  if (error) throw error;
  return data?.[0] ?? null;
}

export async function pauseEmailAlert(token: string) {
  const { data, error } = await supabase.rpc('pause_email_alert', { p_token: token });
  if (error) throw error;
  return data?.[0];
}

export async function resumeEmailAlert(token: string) {
  const { data, error } = await supabase.rpc('resume_email_alert', { p_token: token });
  if (error) throw error;
  return data?.[0];
}

export async function unsubscribeEmailAlert(token: string) {
  const { data, error } = await supabase.rpc('unsubscribe_email_alert', { p_token: token });
  if (error) throw error;
  return data?.[0];
}
